export default __webpack_public_path__ + "static/media/sbo-title-en.befe1c9a.webp";